import { AiOutlineClose } from "react-icons/ai";
import { pollQuestions } from "../../../../static/pollQuestions";

const PollScreen = ({ currentOne, setShowGraph, closePoll }) => {
  return (
    <div>
      <div className="absolute right-0 top-0">
        <AiOutlineClose className="h-6 w-6 cursor-pointer bg-red-500 text-white  p-1" onClick={() => closePoll()} />
      </div>
      <h2 className="text-lg font-medium">
        {currentOne + 1}) {pollQuestions[currentOne].question}{" "}
      </h2>
      <div className="grid grid-cols-2 gap-4 mt-6 w-11/12 mx-auto">
        {pollQuestions[currentOne].options.map(({ label, value }) => (
          <button
            key={value}
            className="bg-[#005EEF] bg-opacity-5 text-center px-2 py-[10px] text-xs rounded-full font-medium  text-[#7C868D] hover:text-white hover:bg-[#00A889] transition-all hover:bg-opacity-100 w-full"
            onClick={() => {
              setShowGraph(true);
            }}>
            {label}
          </button>
        ))}
      </div>
      <div className="text-end  mt-8 text-sm">
        {currentOne + 1}/{pollQuestions.length}
      </div>
    </div>
  );
};

export default PollScreen;
